function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Sides } from '../constants';
import getTransition from '../getTransition';
import stopTransitionOnSideChange from '../stopTransitionOnSideChange';
import styled from 'styled-components';

var getDiagonalEndPoint = function getDiagonalEndPoint(_ref) {
  var height = _ref.height,
      _ref$isFixedAngle = _ref.isFixedAngle,
      isFixedAngle = _ref$isFixedAngle === void 0 ? true : _ref$isFixedAngle,
      _ref$angle = _ref.angle,
      angle = _ref$angle === void 0 ? Math.PI / 6 : _ref$angle,
      wipePercentage = _ref.wipePercentage,
      side = _ref.side;

  /**
   * If we want to keep the diagonal at a fixed angle, we
   * calculate the endpoint position based on the angle,
   * the current place where the wipe is, and the height
   * of the containing element.
   */
  if (isFixedAngle) {
    var value = "".concat(height, " * ").concat(Math.tan(angle));
    /**
     * If on the left, need to base the endpoint relative
     * to rightmost point.
     */

    if (side === Sides.Left) {
      return "calc(100% - ".concat(value, " - ").concat(wipePercentage, "%)");
    }

    return "calc(".concat(value, "  + ").concat(wipePercentage, "%)");
  }
  /**
   * If we want a fluid angle (which we do by default)
   * we'll just return the point at 50% of width as the
   * endpoint.
   */


  if (side === Sides.Left) {
    return "calc(".concat(50 - wipePercentage, "%)");
  }

  return "calc(".concat(50 + wipePercentage, "%)");
};
/**
 * getPolygonForPercentage
 * @param {oneOf(Sides)} side
 * @param {number[0-100]} percentage
 * @param {string} height
 * @param {number[0-45]} angle
 * @param {boolean} isFixedAngle
 * getPolygonForPercentage generates a polygon for
 * use with the CSS `clip-path` property.
 */


var getPolygonForPercentage = function getPolygonForPercentage(_ref2) {
  var side = _ref2.side,
      percentage = _ref2.percentage,
      height = _ref2.height,
      angle = _ref2.angle,
      isFixedAngle = _ref2.isFixedAngle;
  var wipePercentage = Math.abs(100 - percentage); // Generate the endpoint based on side, angle, height

  var endpoint = getDiagonalEndPoint({
    angle: angle,
    height: height,
    wipePercentage: wipePercentage,
    isFixedAngle: isFixedAngle,
    side: side
  });

  switch (side) {
    case Sides.Right:
      return "100% 0%, 100% 100%, ".concat(endpoint, " 100%, ").concat(wipePercentage, "% 0%");

    case Sides.Left:
    default:
      return "0 0,".concat(endpoint, " 0,").concat(100 - wipePercentage, "% 100%,0% 100%");
  }
};
/**
 * The main component that is used for have a "cut" image
 * with a diagonal. We use clip-path to create this cut.
 */


var StyledDiagonalCropImage = styled.img.attrs({
  style: function style(props) {
    var clipPath = "polygon(".concat(getPolygonForPercentage({
      side: props.side,
      percentage: props.diagonalWipePercentage,
      height: props.containerHeight,
      angle: props.angle,
      isFixedAngle: typeof props.angle !== 'undefined' && props.angle !== null
    }), ")");
    return {
      clipPath: clipPath,
      '-webkit-clip-path': clipPath,
      objectPosition: props.imagePosition
    };
  }
})(_templateObject(), getTransition);
var DiagonalCropImage = stopTransitionOnSideChange(StyledDiagonalCropImage);
export default DiagonalCropImage;